import styled            from "styled-components"
import { ButtonToolbar } from "react-bootstrap"

const ButtonToolbarStyle = styled(ButtonToolbar)`
    justify-content: center;
    height: 100%;
`

export default ButtonToolbarStyle